import React from "react";
import { connect } from "react-redux";
import SeguridadForm from "./seguridad.frm";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		hashOne: state.registroAF.hashOne,
		hashTwo: state.registroAF.hashTwo,
		apaterno: state.registroAF.apaterno,
		amaterno: state.registroAF.amaterno,
		nombres: state.registroAF.nombres,
		email: state.registroAF.email,
		fechaNacimientoDate: state.registroAF.fechaNacimientoDate,
		genero: state.registroAF.genero,
		ladaCelular: state.registroAF.ladaCelular,
		telCelular: state.registroAF.telCelular,
		rfc: state.registroAF.rfc,
		poliza: state.registroAF.poliza,
		password: state.registroAF.password,
		pregunta1: state.registroAF.pregunta1,
		pregunta2: state.registroAF.pregunta2,
		respuesta1: state.registroAF.respuesta1,
		respuesta2: state.registroAF.respuesta2,
		mediosElectronicos: state.registroAF.mediosElectronicos,
		datosPersonales: state.registroAF.datosPersonales,
		dispositivo: state.global.dispositivo,
		avisoAceptado: state.registro.avisoAceptado
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		siguientePaso: () => {
			dispatch({ "type": "REGISTRO_FAMILIAR_PASO", paso: 2 });
		},
		registrarDatos(oDatosForm, bAccept) {
			dispatch({
				"type": "REGISTRO_FAMILIAR_SEGURIDAD",
				"password": oDatosForm.password,
				"pregunta1": oDatosForm.pregunta1,
				"respuesta1": oDatosForm.respuesta1,
				"pregunta2": oDatosForm.pregunta2,
				"respuesta2": oDatosForm.respuesta2
			});
			dispatch({ "type": "REGISTRO_FAMILIAR_CONTRATO_DP", "datosPersonales": bAccept });
			dispatch({ "type": "REGISTRO_FAMILIAR_CONTRATO_ME", "mediosElectronicos": bAccept });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		limpiarRegistro: () => {
			dispatch({ "type": "LIMPIAR_REGISTRO" });
			dispatch({ "type": "LIMPIAR_REGISTRO_ASISTIDO" });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
	};
};

class Seguridad extends React.Component {

	state = {
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
		isModalOpened: false,
		modalMesage: { type: null, title: null, message: null }
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	enviarLogin = () => {
		this.props.tagManager({ "type": "EVENT_REGISTRO_FINALIZADO-ACEPTAR", "dispositivo": this.props.dispositivo });
		this.props.limpiarRegistro();

		if (this.props.dispositivo === 'app') {
			const mensaje = { "return": "home" };
			movil("", mensaje);
			this.closeModalSuccessFromChild();
		} else {
			goTo("login");
		}
	}

	openModalSuccessParent = (type, title, message) => {
		const { isModalSuccessOpened } = this.state;

		if (isModalOpened){
			this.setState({ isModalOpened: false, modalMesage: { type: null, title: null, message: null } })
		}else {
			this.setState({ isModalOpened: true });
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false, modalMesage: { type: null, title: null, message: null } });
	}

	submit = (data) => {
		this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_SEGURIDAD-CORRECTOS", "dispositivo": this.props.dispositivo });

		this.props.loader(true);
		return new Promise((resolve) => {
			this.props.registrarDatos(data);
			setTimeout(() => {
				this.props.loader(false);
				this.props.siguientePaso();
			}, 2000);
			resolve();
		});
	}

	render() {
		return (<div>
			<SeguridadForm onSubmit={this.submit} />

			<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
				show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
			</ModalSintillo>

			<div className="modal modal-msj fade" id="modal-bienvenida" tabIndex="-1" role="dialog" aria-labelledby="id-modal-bienvenida">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="">
							<h5 id="id-modal-title" className="text-center">¡Bienvenido!</h5>
						</div>
						<div className="txt-black">
							<p>Tu información se ha guardado satisfactoriamente.</p>
							<p>De ahora en adelante deberás acceder a tu sesión ingresando tu correo y contraseña, mismos que podrás utilizar en la aplicación Soy Cliente GNP. Recibirás un SMS con tu número de cliente, el cual podrás utilizar para los servicios del call center.</p>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="button" className="btn orange-btn" onClick={this.enviarLogin} data-dismiss="modal">Aceptar</button>
						</div>
					</div>
				</div>
			</div>

			{this.state.isModalSuccessOpened &&
				<Modal closeModalFromChild={this.closeModalSuccessFromChild}>
					<div>
						<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
								<img src={require('../img/verified_user_success.svg')} alt="Success image modal" className="gnp-material-comtent-image" />
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
								<label className="gnp-material-title-modal">¡Bienvenido!</label>
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
								<p className=" gnp-material-content-modal">Tu información se ha guardado satisfactoriamente.</p>
								<p className=" gnp-material-content-modal">Recibirás un SMS con tu número de cliente, el cual  se te solicitará para utilizar los servicios de Call Center. De ahora en adelante deberás acceder a tu sesión ingresando tu usuario y contraseña.</p>
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
								<button type="button" onClick={this.enviarLogin} className="pure-material-button-contained btn-full-width">Aceptar</button>
							</div>
						</div>
					</div>
				</Modal>}

			{this.state.isModalErrorOpened &&
				<Modal closeModalFromChild={this.closeModalErrorFromChild}>
					<div>
						<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
								<img src={require('../img/warning-new-style.svg')} alt="Error image modal" className="gnp-material-comtent-image" />
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
								<label className="gnp-material-title-modal">{this.state.modalErrorMessage.title}</label>
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
								{this.state.modalMesage.type === "error" ?
									<p className=" gnp-material-content-modal">{this.state.modalMesage.message}</p>
									:
									<div>
										<p className=" gnp-material-content-modal">Tu información se ha guardado satisfactoriamente.</p>
										<p className=" gnp-material-content-modal">Recibirás un SMS con tu número de cliente, el cual  se te solicitará para utilizar los servicios de Call Center. De ahora en adelante deberás acceder a tu sesión ingresando tu usuario y contraseña.</p>
									</div>
								}

							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
								<button type="button" onClick={this.state.modalMesage.type === 'error' ? this.closeModalFromChild : this.enviarLogin} className="pure-material-button-contained btn-full-width">{this.state.modalMesage.type === 'error' ? 'OK' : 'Aceptar'}</button>
							</div>
						</div>
					</div>
				</Modal>}
		</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Seguridad);


// WEBPACK FOOTER //
// ./src/gnp-registro-familiar/seguridad.cmpt.js